import React from 'react';
import { Send } from 'lucide-react';
import { useSite } from '../context/SiteContext';
import { resolveImage } from '../utils/imageHelper';

const Header = () => {
  const { settings } = useSite() || {};
  const telegram = settings?.telegramLink || 'https://t.me/';
  const siteTitle = settings?.siteTitle || 'GoGoYonoGames.com';
  const logoUrl = settings?.logoUrl ? resolveImage(settings.logoUrl) : '';

  return (
    <header className="w-full bg-[#6a1b7d] text-white sticky top-0 z-40 shadow-md">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-3 py-2">
        <a href="/" className="flex items-center gap-2">
          {logoUrl ? (
            <img src={logoUrl} alt={siteTitle} className="w-11 h-11 rounded-full object-cover border-2 border-yellow-400 shadow" />
          ) : (
            <div className="w-11 h-11 rounded-full bg-yellow-300 border-2 border-yellow-400 flex items-center justify-center overflow-hidden shadow">
              <div className="text-[10px] leading-tight font-extrabold text-red-700 text-center tracking-tight">
                GOGO<br/>YONO<br/>GAMES
              </div>
            </div>
          )}
        </a>
        <h1 className="text-white text-lg sm:text-xl md:text-2xl font-semibold text-center flex-1">
          {siteTitle}
        </h1>
        <a
          href={telegram}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center w-10 h-10 rounded-md bg-[#2ea6e0] hover:bg-[#1f95cf] transition-colors shadow"
          aria-label="Telegram"
        >
          <Send className="w-5 h-5 text-white" fill="white" />
        </a>
      </div>
    </header>
  );
};

export default Header;
